/// Formatos de gravação por preferência: OGG (Firefox), WebM (Chrome, Edge, Brave), MP4 (Safari).
export const VOICE_MIME_TYPES = [
    'audio/ogg;codecs=opus',
    'audio/webm;codecs=opus',
    'audio/webm',
    'audio/mp4',
];

/// O primeiro formato que o navegador sabe gravar, ou nulo.
export const pickVoiceMime = (isSupported: (mime: string) => boolean): string | null =>
    VOICE_MIME_TYPES.find((mime) => isSupported(mime)) ?? null;

/// O tipo sem o codec, que é o que o Blob da gravação leva.
export const baseMime = (mime: string) => mime.split(';')[0].trim();

/// Nome da nota de voz que chega ao cliente, com a data da gravação.
export const voiceFileName = (at: Date) => {
    const pad = (n: number) => String(n).padStart(2, '0');
    const stamp = `${at.getFullYear()}-${pad(at.getMonth() + 1)}-${pad(at.getDate())}`
        + `-${pad(at.getHours())}${pad(at.getMinutes())}${pad(at.getSeconds())}`;

    return `audio-${stamp}.ogg`;
};

export const recordingClock = (seconds: number) =>
    `${Math.floor(seconds / 60)}:${String(Math.floor(seconds % 60)).padStart(2, '0')}`;
